import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSocialSharing from 'vue-social-sharing';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store';

import 'normalize.css';
import 'frow';
import 'bulma';

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import Snotify,  { SnotifyPosition } from 'vue-snotify';
import 'vue-snotify/styles/material.css';

import wysiwyg from 'vue-wysiwyg';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      store.commit('logout');
    }
    return Promise.reject(error);
  },
);

Vue.prototype.$API = `${location.protocol}//${process.env.VUE_APP_API}`;
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

Vue.use(wysiwyg, {
  forcePlainTextOnPaste: true,
});
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSocialSharing);

Vue.component('multiselect', Multiselect);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
